module.exports = __webpack_public_path__ + "img/nav-list.046f2d98.svg";